import React, { useRef, useState } from "react";
import Input from "../../UI/Input";

import classes from "./MealItemForm.module.css";

const MealItemForm = props => {

  const [amountIsValid, setAmountIsValid] = useState(true);

  const amountInputref = useRef();

  const submitHandler = event => {
    event.preventDefault();

    const enteredAmount = amountInputref.current.value;
    const enteredAmountNUmber = +enteredAmount;

    if(enteredAmount.trim().length === 0 || enteredAmount < 1 || enteredAmount > 5) {
      setAmountIsValid(false);
      return;
    }

    props.onAddToCart(enteredAmountNUmber);
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
      <Input ref={amountInputref} label="Amount" input={{
        id: "Amount",
        type: "number",
        min: "1",
        max: "5",
        step: "1",
        defaultValue: "1"
      }} />
      <button>+ Add</button>
      {!amountIsValid && <p>Please enter a valid amount ( 1-5 )</p>}
    </form>
  );
};

export default MealItemForm;